import React from 'react';
import { PageProps } from 'gatsby';
import Button from 'atoms/Button/Button';
import { IMenuLink } from './HeaderLinks';
import Stack from 'atoms/Layout/Stack/Stack';
import HeaderCta from 'molecules/Header/Header/HeaderCta';
import Clickable from 'atoms/Clickable/Clickable';
import HeaderMenuLink from 'molecules/Header/Header/HeaderMenuLink';
import MightyLogo from 'src/app/icons/Custom/Logos/Mighty/Mighty';
import { BreakpointType } from 'atoms/Layout/Visibility.styles';
import { HeaderLinks, HeaderCtaContainer } from './Header.styles';
import { useHeaderCustomization } from 'src/hooks/useHeaderCustomization';
import Fade from 'molecules/Fade/Fade';

interface HeaderDesktopProps {
  isPro: boolean;
  hideOn: BreakpointType;
  topBarLinks: IMenuLink[] | undefined;
  locationProps: PageProps['location'];
}

const HeaderDesktop = ({ isPro, hideOn, topBarLinks, locationProps }: HeaderDesktopProps): JSX.Element => {
  const { links: customLinks, hideCallToAction = false, hideSecondaryCallToAction = false, disableLogoLink = false } = useHeaderCustomization();

  const links = customLinks ?? topBarLinks;

  return (
    <Stack
      align='center'
      hideOn={hideOn}
      direction='row'
      justify='flex-start'
      gap={'spacing-2xl'}
      className='header-content'
    >
      {disableLogoLink ? (
        <MightyLogo width={103.758} />
      ) : (
        <Clickable href='/' data-track-id='mighty-logo'>
          <MightyLogo width={103.758} />
        </Clickable>
      )}
      <Fade visible={!!links}>
        <HeaderLinks
          direction='row'
          gap={'spacing-xs'}
          align='center'
          justify='flex-start'
        >
          {links?.map((link) => (
            <HeaderMenuLink
              key={link.text}
              text={link.text}
              href={link.href}
              locationPathname={locationProps.pathname}
              trackingSlug={link.trackingSlug}
              useExpandableMenu={link.useExpandableMenu}
              expandableMenu={link.expandableMenu}
            />
          ))}
        </HeaderLinks>
      </Fade>
      <HeaderCtaContainer
        direction='row'
        gap={'spacing-lg'}
        align='center'
        justify='flex-end'
        dataCy='header-cta-container'
      >
        {!hideSecondaryCallToAction && (
          <Button
            variant='secondary'
            size='lg'
            href='https://mightynetworks.com/sign_in'
          >
            Log In
          </Button>
        )}
        {!hideCallToAction && <HeaderCta callToAction={isPro ? 'pro' : 'standard'} />}
      </HeaderCtaContainer>
    </Stack>
  );
};

export default HeaderDesktop;
